import { useTranslation } from 'react-i18next';
import propTypes from 'prop-types';
import * as S from './styles';

const Banner = ({ bannerImageUrl, bannerPosition }) => {
  const [t] = useTranslation('personalized-invite');

  return (
    <S.BannerImage
      src={bannerImageUrl}
      alt={t('banner-alt')}
      $bannerPosition={bannerPosition}
    />
  );
};

Banner.propTypes = {
  bannerImageUrl: propTypes.string.isRequired,
  bannerPosition: propTypes.string,
};

Banner.defaultProps = {
  bannerPosition: 'top',
};

export default Banner;
